export type JurisdictionRule = {
  /** Searched in certificate file names. */
  filenameKeyword: string;
  marketName?: string;
  language?: string;
};

const JurisdictionRules: JurisdictionRule[] = [
  {
    filenameKeyword: 'BAC',
    marketName: 'buenos_aires',
    language: 'es',
  },
  { filenameKeyword: 'BRA', marketName: 'brazil', language: 'pt' },
  { filenameKeyword: 'CHE', marketName: 'switzerland' },
  { filenameKeyword: 'COL', marketName: 'colombia', language: 'es' },
  { filenameKeyword: 'ESP', marketName: 'spain', language: 'es' },
  { filenameKeyword: 'GEO', marketName: 'georgia' },
  { filenameKeyword: 'GRC', marketName: 'greece', language: 'el' },
  { filenameKeyword: 'ITA', marketName: 'italy', language: 'it' },
  { filenameKeyword: 'DGE', marketName: 'us_nj' },
  { filenameKeyword: 'NLD', marketName: 'netherlands' },
  { filenameKeyword: 'ONT', marketName: 'ontario' },
  { filenameKeyword: 'PEN', marketName: 'us_pa' },
  { filenameKeyword: 'PER', marketName: 'peru', language: 'es' },
  { filenameKeyword: 'PRT', marketName: 'portugal', language: 'pt' },
  { filenameKeyword: 'ROU', marketName: 'romania', language: 'ro' },
  { filenameKeyword: 'GBR', marketName: 'mga' },
  { filenameKeyword: 'WVA', marketName: 'us_wv' },
  { filenameKeyword: 'ALB', marketName: 'alberta' },
];

export default JurisdictionRules;
